"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray")),
    _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray")),
    _react = _interopRequireWildcard(require("react")),
    _uiKit = require("@devsta/ui-kit");

require("./styles/_expandable-addon.scss");

var MULTI = "MULTI",
    SINGLE = "SINGLE",
    YES_NO = "YES_NO";

function toggleAddonEnabled(a, b, c, d) {
  return function () {
    var e = !b;
    return a(e), d === YES_NO && e ? void c({
      value: !0
    }) : void (e || c(null));
  };
}

function onChangeAddonValue(a, b, c, d) {
  return function () {
    if (c === MULTI && !a) return void d([b]);

    if (c === MULTI) {
      var e = a.findIndex(function (a) {
        var c = a.value;
        return c === b.value;
      });
      if (-1 === e) return void d([].concat((0, _toConsumableArray2["default"])(a), [b]));
      var f = (0, _toConsumableArray2["default"])(a);
      return f.splice(e, 1), void d(f);
    }

    d(b);
  };
}

function isValueSelected(a, b) {
  return Array.isArray(a) ? a.some(function (a) {
    var c = a.value;
    return b === c;
  }) : a && a === b;
}

function ExpandableAddon(a) {
  var b = a.title,
      c = a.subtitle,
      d = a.options,
      e = a.costFrom,
      f = a.suffixDoubleDagger,
      g = a.onChangeAddon,
      h = a.addonValue,
      i = a.type,
      j = void 0 === i ? SINGLE : i,
      k = a.disabled,
      l = (0, _react.useState)(!!h),
      m = (0, _slicedToArray2["default"])(l, 2),
      n = m[0],
      o = m[1],
      p = j === SINGLE ? _uiKit.RadioButton : _uiKit.Checkbox,
      q = j === YES_NO ? d.find(function (a) {
    var b = a.value;
    return b;
  }) : d.reduce(function (a, b) {
    var c = b.cost,
        d = "".concat(c).match(/\d+/)[0];
    return 0 === Object.keys(a).length || d < a.numberCost ? {
      numberCost: d,
      cost: c
    } : a;
  }, {}),
      r = q.cost;
  return _react["default"].createElement("div", {
    className: "expandable-addon"
  }, _react["default"].createElement("div", {
    className: "expandable-addon__checkbox"
  }, _react["default"].createElement(_uiKit.Checkbox, {
    checked: n,
    onChange: toggleAddonEnabled(o, n, g, j),
    disabled: k
  }, b), _react["default"].createElement(_uiKit.Text, {
    highlighted: !0,
    suffixDoubleDagger: f,
    noMargin: !0
  }, "".concat(e ? "from" : "", " ").concat(r))), _react["default"].createElement(_uiKit.Text, {
    className: "expandable-addon__subtitle",
    label: !0,
    noMargin: !0
  }, c), n && j !== YES_NO && _react["default"].createElement("div", {
    className: "expandable-addon__children"
  }, d.map(function (a) {
    if (!a.value) return null;
    var b = isValueSelected(h, a.value);
    return _react["default"].createElement("div", {
      className: "expandable-addon__checkbox"
    }, _react["default"].createElement(p, {
      checked: b,
      selected: b,
      prefixIcon: a.prefix || a.icon,
      onChange: onChangeAddonValue(h, a, j, g),
      disabled: k
    }, a.label), _react["default"].createElement(_uiKit.Text, {
      highlighted: !0,
      noMargin: !0
    }, a.cost));
  })));
}

var _default = (0, _react.memo)(ExpandableAddon);

exports["default"] = _default;